import { getFirebaseAuth } from "@src/firebaseConfig";
import { VITE_BACKPACK_URL } from "@src/env";
import {
  signOut as firebaseSignOut,
  updatePassword as firebaseUpdatePassword,
  reauthenticateWithCredential as firebaseReauthenticateWithCredential,
  EmailAuthProvider,
  sendPasswordResetEmail,
} from "firebase/auth";

export async function getIdToken(forceRefresh = false) {
  const { currentUser } = getFirebaseAuth();
  return await currentUser?.getIdToken(forceRefresh);
}

export function signOut() {
  return firebaseSignOut(getFirebaseAuth());
}

export async function updatePassword(newPassword: string) {
  const user = getFirebaseAuth().currentUser;
  if (!user) throw new Error("No current user.");
  return firebaseUpdatePassword(user, newPassword);
}
export async function reauthenticateWithCredential(currentPassword: string) {
  const user = getFirebaseAuth().currentUser;
  if (!user?.email) throw new Error("No current user or email.");
  const credential = EmailAuthProvider.credential(user.email, currentPassword);
  return firebaseReauthenticateWithCredential(user, credential);
}

function isBackpackUrl(url: string) {
  try {
    return (
      new URL(url, VITE_BACKPACK_URL).origin ===
      new URL(VITE_BACKPACK_URL).origin
    );
  } catch {
    return false;
  }
}

export function getSafeContinueUrl(continueUrl: string | null | undefined) {
  return continueUrl && isBackpackUrl(continueUrl)
    ? continueUrl
    : VITE_BACKPACK_URL;
}

export async function sendPasswordResetEmailWhenSignedIn(continueUrl: string) {
  const { email } = getFirebaseAuth().currentUser ?? {};
  if (!email) throw new Error("Invalid email address");
  return sendPasswordResetEmail(getFirebaseAuth(), email, { url: continueUrl });
}
